
//系统目录 / 字段 接口相关的函数
import request from "@/untils/request.js"

/**
 * 
 *  post
 *  
 */

// 字段 = > 分页
export const FieldList = (data) => {
    return request.post("/outpatient/standard/page", data )
}

// 用于新建字段
export const addField = (data) => {
    return request.post("/outpatient/eisai/add", data )
}

// 修改字段
export const updateField = (data) => {
    return request.post("/outpatient/standard/edit", data )
}


/**
 * 
 * get 
 *  
 */

// 查询字段设置分类编码和名称
export const FieldType = (params) => {
    return request.get("/outpatient/standard/type", { params })
}

// // 查看字段种类列表
// export const detailEisai = (params) => {
//     return request.get("/outpatient/eisai/detail", { params })
// }

// // 删除单条字段项目
// export const deleteEisai = (params) => {
//     return request.delet("/outpatient/eisai/delete", { params })
// }

/*
 * 
 * DELETE 
 *   
 */   


// 暴露
export default{
    FieldList,
    addField,
    updateField,
    FieldType
}